import React from 'react';
import { MdImportantDevices, MdLoyalty } from 'react-icons/md';

import { SidebarContext } from '../../context/SidebarContext';
import { AppWrapper, TABLET_MIN } from '../../constants/styledComponents';
import { DeviceStatusBanner } from '../StatusBanner';

import { Content, Footer, Header, Sidebar } from '.';

class MainLayout extends React.Component {
  static contextType = SidebarContext;
  componentDidMount() {
    this.checkBreakpoint();

    setTimeout(() => {
      if (!this.notificationSystem) {
        return;
      }

      this.notificationSystem.addNotification({
        title: <MdImportantDevices />,
        message: 'Welcome to SONDA Admin!',
        level: 'info',
      });
    }, 1500);

    setTimeout(() => {
      if (!this.notificationSystem) {
        return;
      }

      this.notificationSystem.addNotification({
        title: <MdLoyalty />,
        message: 'SONDA is developed by Reyedar B.V.!',
        level: 'info',
      });
    }, 2500);
  }

  handleContentClick = () => {
    const { isSidebarOpen, closeSidebar } = this.context;

    // Only the mobile overlay covers the content, so only it dismisses on tap.
    if (isSidebarOpen && window.innerWidth < TABLET_MIN) {
      closeSidebar();
    }
  };

  checkBreakpoint() {
    const { openSidebar, closeSidebar } = this.context;

    // Visible on tablet (rail) and desktop (full); hidden on mobile.
    if (window.innerWidth >= TABLET_MIN) {
      openSidebar();
    } else {
      closeSidebar();
    }
  }

  render() {
    const { children } = this.props;
    const { isSidebarOpen } = this.context;

    return (
      <AppWrapper>
        <Sidebar />
        <Content isSidebarOpen={isSidebarOpen} onClick={this.handleContentClick}>
          <Header currentUser={this.props.currentUser} />
          <DeviceStatusBanner />
          {children}
          <Footer />
        </Content>
      </AppWrapper>
    );
  }
}

export default MainLayout;
